export const PTFlagRound = ({ width = "32px", height = "32px" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 64 64"
    >
      <path d="M17 58V6C8 11.2 2 20.9 2 32s6 20.8 15 26" fill="#699635" />
      <path
        d="M32 2c-5.5 0-10.6 1.5-15 4v52c4.4 2.6 9.5 4 15 4 16.6 0 30-13.4 30-30S48.6 2 32 2"
        fill="#ed4c5c"
      />
      <g fill="#ffe62e">
        <path d="M17 20c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12m0 22.5c-5.8 0-10.5-4.7-10.5-10.5S11.2 21.5 17 21.5 27.5 26.2 27.5 32 22.8 42.5 17 42.5" />
        <path d="M21.1 43.7c-.2.2-.5.2-.7 0L6.7 25.6c-.2-.2-.2-.5 0-.7l.3-.3c.2-.2.5-.2.7 0l13.7 18.1c.2.2.2.5 0 .7z" />
        <path d="M17.2 19.5c.3 0 .5.2.5.5v24c0 .3-.2.5-.5.5h-.5c-.3 0-.5-.2-.5-.5V20c0-.3.2-.5.5-.5z" />
        <path d="M28.9 33.3 17 31.2v1.5l11.7 2.1c.3 0 .5-.1.6-.4l.1-.5c0-.2-.2-.5-.5-.6M17 31.1l-9.4-6.6c-.2-.2-.5-.1-.7.1l-.3.4c-.2.2-.1.5.1.7L17 32.9z" />
        <path d="m16.6 30-9.4 9.4c-.2.2-.2.5 0 .7l.4.4c.2.2.5.2.7 0l8.3-8.3zm.4-4.5L4.5 31.4c-.2.1-.4.4-.2.7l.2.5c.1.2.4.4.7.2L17 27.2z" />
        <path d="m28.1 27.2-11.9-2.1v1.5l11.7 2.1c.3 0 .5-.1.6-.4l.1-.5c-.1-.3-.3-.6-.5-.6M16.9 38.9c-.2.1-.4.4-.2.7l.2.5c.1.2.4.4.7.2l10-4.6.5-1.9zm0-3.4L5.7 31.4V33l11.2 4.1z" />
        <path d="M9.1 38.8v1.5l14.8 1c.6-.4 1.1-.9 1.6-1.4z" />
      </g>
      <path d="M12 27v7c0 2.8 2.2 5 5 5s5-2.2 5-5v-7z" fill="#fff" />
      <path
        d="M17 41c-3.9 0-7-3.1-7-7v-9h14v9c0 3.9-3.1 7-7 7m-3-12v5c0 1.7 1.3 3 3 3s3-1.3 3-3v-5z"
        fill="#ed4c5c"
      />
      <path
        d="M16.1 29.4V31c0 .3.2.5.5.5h.8c.3 0 .5-.2.5-.5v-1.7h-1.8zm0 2.5v1.7c0 .3.2.5.5.5h.8c.3 0 .5-.2.5-.5v-1.7zm-2 0v1.7c0 .3.2.5.5.5h.8c.3 0 .5-.2.5-.5v-1.7zm4 0v1.7c0 .3.2.5.5.5h.8c.3 0 .5-.2.5-.5v-1.7zm-2 2.4V36c0 .3.2.5.5.5h.8c.3 0 .5-.2.5-.5v-1.7z"
        fill="#0071bc"
      />
      <g fill="#fff">
        <circle cx="17" cy="32.9" r=".2" />
        <circle cx="16.6" cy="33.4" r=".2" />
        <circle cx="17.4" cy="33.4" r=".2" />
        <circle cx="16.6" cy="32.4" r=".2" />
        <circle cx="17.4" cy="32.4" r=".2" />
        <circle cx="17" cy="30.4" r=".2" />
        <circle cx="16.6" cy="30.9" r=".2" />
        <circle cx="17.4" cy="30.9" r=".2" />
        <circle cx="16.6" cy="29.9" r=".2" />
        <circle cx="17.4" cy="29.9" r=".2" />
        <circle cx="19" cy="32.9" r=".2" />
        <circle cx="18.6" cy="33.4" r=".2" />
        <circle cx="19.4" cy="33.4" r=".2" />
        <circle cx="18.6" cy="32.4" r=".2" />
        <circle cx="19.4" cy="32.4" r=".2" />
        <circle cx="15" cy="32.9" r=".2" />
        <circle cx="14.6" cy="33.4" r=".2" />
        <circle cx="15.4" cy="33.4" r=".2" />
        <circle cx="14.6" cy="32.4" r=".2" />
        <circle cx="15.4" cy="32.4" r=".2" />
        <circle cx="17" cy="35.4" r=".2" />
        <circle cx="16.6" cy="35.9" r=".2" />
        <circle cx="17.4" cy="35.9" r=".2" />
        <circle cx="16.6" cy="34.9" r=".2" />
        <circle cx="17.4" cy="34.9" r=".2" />
      </g>
      <path
        fill="#ffe62e"
        d="M16 28h2l-.2-1v-1h.2v-.5h-.3v.3h-.1v-.3h-.3v.3h-.2v-.3h-.2v.3h-.2v-.3h-.3v.3h-.2v-.3H16v.5h.2v1z"
      />
      <path
        d="M17.3 28h-.1v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2v.4h-.1v-.4q0-.3.3-.3t.3.3zm-.3-1.1h-.6v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2zm1.1.1H17v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2z"
        fill="#3e4347"
      />
      <path
        fill="#ffe62e"
        d="M11 28h2l-.2-1v-1h.2v-.5h-.3v.3h-.1v-.3h-.3v.3h-.2v-.3h-.2v.3h-.2v-.3h-.3v.3h-.2v-.3H11v.5h.2v1z"
      />
      <g fill="#3e4347">
        <path d="M12.3 28h-.1v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2v.4h-.1v-.4q0-.3.3-.3t.3.3zm-.3-1.1h-.6v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2z" />
        <path d="M12.6 26.9H12v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2z" />
      </g>
      <path
        fill="#ffe62e"
        d="M11 33.9h2l-.2-1v-1h.2v-.5h-.2v.3h-.2v-.3h-.2v.3h-.3v-.3h-.2v.3h-.2v-.3h-.2v.3h-.2v-.3H11v.5h.3v1z"
      />
      <path
        d="M12.3 33.9h-.1v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2v.4h-.1v-.4q0-.3.3-.3t.3.3zm-.3-1.1h-.6v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2zm1.2.1h-.6v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2z"
        fill="#3e4347"
      />
      <path
        fill="#ffe62e"
        d="M21 34h2l-.2-1v-1h.2v-.4h-.3v.2h-.1v-.2h-.3v.2h-.2v-.2h-.2v.2h-.2v-.2h-.3v.2h-.2v-.2H21v.4h.2v1z"
      />
      <path
        d="M22.3 34h-.1v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2v.4h-.1v-.4q0-.3.3-.3t.3.3zm-.3-1.1h-.6v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2zm1.1.1H22v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2z"
        fill="#3e4347"
      />
      <path
        fill="#ffe62e"
        d="M21 28h2l-.2-1v-1h.2v-.5h-.3v.3h-.1v-.3h-.3v.3h-.2v-.3h-.2v.3h-.2v-.3h-.3v.3h-.2v-.3H21v.5h.2v1z"
      />
      <path
        d="M22.3 28h-.1v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2v.4h-.1v-.4q0-.3.3-.3t.3.3zm-.3-1.1h-.6v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2zm1.1.1H22v-.5q0-.3.3-.3t.3.3zm-.5-.1h.4v-.4c0-.1-.1-.2-.2-.2s-.2.1-.2.2z"
        fill="#3e4347"
      />
      <path
        fill="#ffe62e"
        d="m14.2 39.6 1.4-1.5-.9-.5-.7-.7.2-.2-.3-.3-.2.2.2.2-.1.1-.2-.2-.2.2.2.1-.2.2-.1-.2-.2.2.2.2-.2.1-.1-.2-.2.2.1.2-.1.1-.1-.2-.2.2.3.3h.1l.1-.1.7.7z"
      />
      <path
        d="m15.1 38.6-.4-.2q-.15-.15-.3 0t0 .3l.3.3-.1.1-.3-.3c-.1-.1-.1-.3 0-.4s.3-.1.4 0zm-1-.5-.4.4-.3-.3c-.1-.1-.1-.3 0-.4s.3-.1.4 0zm-.4.3.3-.3-.3-.3q-.15-.15-.3 0c-.15.15-.1.2 0 .3zm.9-.8-.4.4-.3-.3c-.1-.1-.1-.3 0-.4s.3-.1.4 0zm-.4.3.3-.3-.3-.3q-.15-.15-.3 0c-.15.15-.1.2 0 .3z"
        fill="#3e4347"
      />
      <path
        fill="#ffe62e"
        d="m19.8 39.6-1.4-1.5.8-.5.7-.7-.1-.2.3-.3.2.2-.2.2.1.1.2-.2.2.2-.2.1.2.2.1-.2.2.2-.2.2.2.1.1-.2.2.2-.2.2.2.1.1-.2.2.2-.3.3h-.1L21 38l-.7.7z"
      />
      <path
        d="m18.9 38.6.4-.2q.15-.15.3 0c.15.15.1.2 0 .3l-.4.3.1.1.3-.3c.1-.1.1-.3 0-.4s-.3-.1-.4 0zm1.3-.8c.1-.1.3-.1.4 0s.1.3 0 .4l-.3.3-.4-.4zm.3.3q.15-.15 0-.3t-.3 0l-.2.3.3.3zm-.8-.8c.1-.1.3-.1.4 0s.1.3 0 .4l-.3.3-.4-.4zm.4.3q.15-.15 0-.3t-.3 0l-.3.3.3.3z"
        fill="#3e4347"
      />
    </svg>
  );
};
